
import Vue from "vue";
import { createLogger, mapState } from "vuex";
import {
  TrashIcon,
  PlusIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CalendarIcon,
  XIcon,
  PaperclipIcon
} from 'vue-feather-icons';
import TipTap from "../../commons/RomaTipTap.vue";
import RomaActivityPieForm from "./RomaActivityPieForm.vue";
import { Ripple } from "vuetify/lib/directives/";
import vuex from "../../../store";
// Rich Text editor
import {
  Blockquote,
  Bold,
  BulletList,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  TiptapVuetify,
  Underline,
} from "tiptap-vuetify";
// Lodash
import { groupBy, map, uniqBy } from "lodash";
// Store
import UnitPlanOa from "@/store/planner/objetive/UnitPlanOa";
import UnitPlanActivity from "@/store/planner/activity/UnitPlanActivity";
import UnitPlanActivityIe from "@/store/planner/activity/UnitPlanActivityIe";
import UnitPlanActivityFile from "@/store/planner/activity/UnitPlanActivityFile";
import UnitPlanActivityDua from "@/store/planner/activity/UnitPlanActivityDua";
import DuaCategory from "@/store/planner/activity/DuaCategory";
import UnitPlan from "@/store/units/UnitPlan";
import UnitPlanComments from "@/store/units/UnitPlanComments";
//Interfaces
import { IState } from "@/interfaces/IState";
import moment from "moment";
import _ from "lodash";
import { format, parseISO } from "date-fns";
import { nonWorkingDates } from "../../../data/nonWorkingDates";

export default Vue.extend({
  name: "RomaActivityModalForm",
  created(): void {
    this.$store.dispatch("getEvaluationTypes").then((response) => {
      this.evaluationTypes = response.data.content;
    });

    this.$store.dispatch("getInstrumentTypes").then((response) => {
      this.instrumentTypes = response.data.content;
    });

    this.$store.dispatch("getDuas").then((response) => {
      DuaCategory.create({ data: response.data.content });
    });

    this.$store.dispatch("getUnitPlanWeeks", this.unit.id).then((response) => {
      let nonWorkingDatesFormatted = nonWorkingDates.map((dates: any) => {
        return {
          init: moment(dates.initialDate),
          end: moment(dates.finalDate)
        };
      });
      response.data.content.forEach((element) => {
        this.monthOptions.push({
          label: element.mes,
          value: element.mes,
        });
        element.semanas.forEach((week, index) => {
          const initDate = moment(`${week.iniAño}-${week.iniMes}-${week.iniDia}`, 'YYYY-MM-DD');
          const endDate = moment(`${week.finAño}-${week.finMes}-${week.finDia}`, 'YYYY-MM-DD');
          let isNonWorking = nonWorkingDatesFormatted.some((dates: any) => {
            return initDate.isBetween(dates.init, dates.end, null, '[]') && endDate.isBetween(dates.init, dates.end, null, '[]');
          });
          if (!isNonWorking) {
            this.weekOptions.push({
              value: week.id,
              label: `${initDate.format("DD/MM/YYYY")} - ${endDate.format(
                "DD/MM/YYYY"
              )}`,
              initDate,
              endDate,
            });
          }
        });
      });
    });
    this.setDefaultValues();
    this.$emit("refresh-activities", true);
  },
  props: {
    value: Boolean,
    activity: Object,
    maxWidth: {
      type: String,
      default: "100%",
    },
    overlayOpacity: {
      type: String,
      default: "0.8",
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    unit: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
    },
    weekItem: Object,
    monthItem: Object
  },
  data() {
    return {
      tab: 0,
      tabEvaluation: [0],
      tabSelected: 0,
      selectIEMode: true,
      valid: false,
      loading: false,
      showing: this.value,
      userId: this.$store.state.user.userId,
      isUTP: this.$store.state.user.isUTP,
      activityTypeOptions: [
        {
          label: "Por clase",
          value: "1",
        },
        {
          label: "Por semana",
          value: "2",
        },
        {
          label: "Por mes",
          value: "3",
        },
      ],
      evaluationTypes: [],
      instrumentTypes: [],
      menu: false,
      weekOptions: [],
      monthOptions: [],
      activityType: "1",
      fechaDefault: "",
      fechaClase: "",
      mesClase: "",
      semanaClase: "",
      activityTitle: "",
      selectedIEsBaseFromUnit: [],
      selectedIEs: [],
      selectedDuaCategory: null,
      selectedDuas: [],
      pies: [],
      filesAux: [],
      request: this.requestDefaultValues(),
      moments: [this.requestDefaultValues("Inicio"), this.requestDefaultValues("Desarrollo"), this.requestDefaultValues("Cierre")],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.fechaClase
        ? moment(this.fechaClase).locale("es").format("DD-MM-YYYY")
        : "";
    },
    unitOAs() {
      let unitOAs = UnitPlanOa.getAllByPlanUnidad(this.unit.id, true).map(
        (detail) => detail.oa
      );

      if (!this.selectIEMode) {
        const selectedIEIds = this.selectedIEs.map((ie: any) => ie.id);
        unitOAs = unitOAs.map((oa) => {
          oa.ies = oa.ies.filter((ie) => selectedIEIds.includes(ie.id));
          return oa;
        }).filter((oa: any) => {
          return oa.ies.length > 0;
        });
      }
      return unitOAs;
    },
    getAllOas() {
      return UnitPlanOa.getAllByPlanUnidad(this.unit.id, true).map(
        (detail) => detail.oa
      );
    },
    duas() {
      let menu = [];
      DuaCategory.query()
        .with("duas")
        .get()
        .forEach((category) => {
          menu.push({ header: category.name });
          category.duas.forEach((dua) => {
            menu.push({ id: dua.id, name: dua.name, code: dua.code });
          });
        });
      return menu;
    },
    unitFiles: {
      get() {
        return this.request.files;
      },
      set(value: Array<File>) {
        const files: File[] = this.request.files.slice();
        value.forEach((item: File) => {
          if (files.every((file) => file.name !== item.name)) {
            files.push(item);
          }
        });
        this.request.files = files;
      },
    },
    ...mapState({
      userPrivileges(state: IState) {
        return state.user.privileges;
      },
    }),
  },
  watch: {
    activity(value) {
      this.mapActivity(value);
    },
    selected(value) {
      if (value.length > 0 && !this.activity) {
        this.selectedIEs = [];
        value
          .filter((oa) => !oa.disabled && !oa.rescheduled)
          .forEach((oa) => {
            oa.selectedRows
              .filter((ie) => !ie.disabled && !ie.rescheduled)
              .forEach((ie) => {
                this.selectedIEs.push(ie);
              });
            if (oa.selectedRows.length > 0) {
              this.selectedIEs.push(oa);
            }
          });
        this.selectedIEsBaseFromUnit = _.cloneDeep(this.selectedIEs);
        if (this.selectedIEs.length > 0) {
          this.selectIEMode = false;
        }
      }
    },
    value(value) {
      if (!value) {
        this.resetAll();
        this.selectIEMode = true;
        this.tab = 0;
        this.tabEvaluation = [0];
        this.tabSelected = 0;
      }
    },
    moments: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    //  activityType: {
    //   handler(val, oldVal) {
    //     if (this.moments.length > 1 && val > 1 && oldVal == 1) {
    //       if (
    //         confirm(
    //           `Al cambiar el tipo de actividad se borrará los momentos. ¿Desea continuar?`
    //         )
    //       ) {
    //         this.moments[0].titulo = val == 2 ? "Semana" : "Mes";
    //         this.moments = [this.moments[0]];
    //         this.tabEvaluation = [this.tabEvaluation[0]];
    //       } else {
    //         this.$nextTick(() => {
    //           this.activityType = oldVal;
    //         });
    //       }
    //       this.$forceUpdate();
    //     } else {
    //       if (val == 1) {
    //         if(oldVal != 1){
    //             this.moments[0].titulo = "Momento 1";
    //         }
    //       } else {
    //         this.moments[0].titulo = val == 2 ? "Semana" : "Mes";
    //         this.moments = [this.moments[0]];
    //         this.tabEvaluation = [this.tabEvaluation[0]];
    //       }
    //     }
    //     this.validAll();
    //   },
    //   deep: true,
    // },
    activityTitle: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    fechaClase: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    semanaClase: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    mesClase: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    selectedIEs: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    selectedDuas: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    pies: {
      handler(val) {
        this.validAll();
      },
      deep: true,
    },
    weekItem: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.setDefaultValues();
        }
      },
      deep: true
    }
  },
  methods: {
    setDefaultValues() {
      //plantype 0: Mes 1:Semana 2:Clase
      //activityType 3: Mes 2:Semana 1:Clase
      this.activityType = this.unit.planType == 0 ? '3' : this.unit.planType == 1 ? '2' : '1';
      if (this.activityType != 1) {
        this.moments[0].titulo = this.activityType == 2 ? "Semana" : "Mes";
        this.moments = [this.moments[0]];
      }
      this.tabEvaluation = [this.tabEvaluation[0]];
      this.mesClase = this.monthItem ? this.monthItem.mes : '';
      this.semanaClase = this.weekItem ? this.weekItem.id : '';
      this.fechaClase = this.weekItem ? moment(this.weekItem.fechaInicio, 'YYYY-MM-DD').locale("es").format('YYYY-MM-DD') : this.fechaDefault ? moment(this.fechaDefault, 'YYYY-MM-DD').locale("es").format('YYYY-MM-DD') : '';
    },
    requestDefaultValues(title: string = "") {
      return {
        //id: this.moments ? this.moments.length : 0,
        titulo: title,
        actividadMomento: null,
        files: [],
        evaluaciones: [],
      };
    },
    defaultEvaluation() {
      return {
        actividadEvaluacion: "",
        idTipoEvaluacion: null,
        idTipoInstrumentoEvaluacion: null,
        files: [],
      };
    },
    fileInputClicked(files: any) {
      this.filesAux = files;
    },
    fileMomentChanged(momento: any) {
      momento.files = [
        ...this.filesAux,
        ...momento.files
      ];
      this.filesAux = [];
    },
    fileEvaluationChanged(evaluation: any) {
      evaluation.files = [
        ...this.filesAux,
        ...evaluation.files
      ];
      this.filesAux = [];
    },
    addEvaluationToMoment(indexMoment: number) {
      this.moments[indexMoment].evaluaciones.push(this.defaultEvaluation());
    },
    addMoment() {
      let momentTitle = `Momento ${this.moments.length + 1}`
      this.moments.push(this.requestDefaultValues(momentTitle));
      this.tabEvaluation.push(0);
    },
    deleteMoment() {
      this.tab = `${this.moments.lenght - 2}`;
      this.moments.pop();
      this.tabEvaluation.pop();
    },
    allowedDates(dateString: string) {
      const date = moment(dateString);
      let allowed = false;
      for (let i = 0; i < this.weekOptions.length; i++) {
        let init = this.weekOptions[i].initDate;
        let end = this.weekOptions[i].endDate;
        if (date.isSameOrAfter(init) && date.isSameOrBefore(end)) {
          return true;
        }
      }

      return allowed;
    },
    uploadMomentFile(indexMoment: number, files: any) {
      //emulate click on id file-input-moment-0
      const fileInput = document.getElementById(`file-input-moment-${indexMoment}`);
      if (fileInput) {
        this.filesAux = files;
        fileInput.click();
      }
    },
    uploadMomentEvaluationFile(indexMoment: number, indexEvaluation: number, files: any) {
      //emulate click on id file-input-moment-0
      const fileInput = document.getElementById(`file-input-evaluation-${indexMoment}-${indexEvaluation}`);
      if (fileInput) {
        this.filesAux = files;
        fileInput.click();
      }
    },
    deleteDua(duaToDelete: any) {
      this.selectedDuas = this.selectedDuas.filter((dua: any) => dua.id != duaToDelete.id);
    },
    deleteItem(
      indexMoment: number,
      indexEvaluation: number,
      indexFile: number
    ) {
      const fileName =
        this.moments[indexMoment].evaluaciones[indexEvaluation].files[indexFile]
          .name;
      confirm(`¿Está seguro que desea eliminar este item ${fileName} ?`) &&
        this.moments[indexMoment].evaluaciones[indexEvaluation].files.splice(
          indexFile,
          1
        );
    },
    deleteFileMoment(indexMoment: number, index: number) {
      const fileName = this.moments[indexMoment].files[index].name;
      confirm(`¿Está seguro que desea eliminar este item ${fileName} ?`) &&
        this.moments[indexMoment].files.splice(index, 1);
    },
    downloadFile(file: UnitPlanActivityFile) {
      if (file.id) {
        window.open(
          `${this.$store.state.baseURL}/actividad/file/${file.id}`,
          "_blank"
        );
      } else {
        //file is a blob
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
      }
    },
    isOaSelected(OAId: number): boolean {
      return this.selectedIEs.some((ie: any) => ie.oa_id === OAId);
    },
    selectOA(ev: any, selectedOA: any) {
      ev.stopPropagation();
      this.selectedIEs = this.selectedIEs.some(
        (selectedIE: any) => selectedIE.oa_id === selectedOA.id
      )
        ? this.selectedIEs.filter(
          (selectedIE: any) => selectedIE.oa_id !== selectedOA.id
        )
        : this.selectedIEs.concat(selectedOA.ies);
    },
    mapActivity(value: any) {
      if (!value) {
        this.selectIEMode = true;
        this.setDefaultValues();
        return;
      }
      this.selectIEMode = false;
      this.activityType = "";
      if (value.mesClase != "null" && value.mesClase != null) {
        this.activityType = "3";
        this.mesClase = value.mesClase;
      } else if (value.fechaClase != "null" && value.fechaClase != null) {
        this.fechaClase = moment(value.fechaClase, 'YYYY-MM-DD').locale("es").format('YYYY-MM-DD')
        this.activityType = "1";
      } else if (value.semanaClase) {
        this.activityType = "2";
      } else {
        this.activityType = this.unit.planType == 0 ? "3" : this.unit.planType == 1 ? "2" : "1";
      }
      this.semanaClase = value.semanaClase ? value.semanaClase.id : null;
      this.activityTitle = value.title;
      /*
                this.request.activityLer = value.activityLer;
                this.request.activityEva.text = value.activityEva;
                this.request.activityEva.type = value.type;
                this.request.activityEva.instrument = value.instrument;

                // compatibilidad endpoint
                this.request.activityEva.type = value.type_id;
                this.request.activityEva.instrument = value.instrument_id;
                */
      this.selectedIEs = value.ies;
      this.selectedIEs = [];
      if (this.selected) {
        this.selected.filter((oa) => !oa.disabled && !oa.rescheduled)
          .forEach((oa) => {
            oa.selectedRows
              .filter((ie) => !ie.disabled && !ie.rescheduled)
              .forEach((ie) => {
                this.selectedIEs.push(ie);
              });
            if (oa.selectedRows.length > 0) {
              this.selectedIEs.push(oa);
            }
          });
      }

      if (this.selectedIEs.length == 0 && value.ies) {
        this.selectedIEs = value.ies;
      }

      this.moments = _.sortBy(value.momentos, 'id', 'asc').map((moment) => {
        const momentElement = {
          id: moment.id,
          actividadMomento: moment.actividadMomento,
          titulo: this.activityType == "1" ? moment.titulo : this.activityType == "2" ? "Semana" : "Mes",
          files: moment.fileList,
        };

        const evaluaciones = _.sortBy(moment.evaluaciones, 'id', 'asc').map((evaluation) => {
          const evaluationMoment = {
            id: evaluation.id,
            actividadEvaluacion: evaluation.actividadEvaluacion,
            idTipoEvaluacion: evaluation.tipoEvaluacion.id,
            idTipoInstrumentoEvaluacion:
              evaluation.tipoInstrumentoEvaluacion.id,
            files: evaluation.fileList,
          };

          return evaluationMoment;
        });

        momentElement.evaluaciones = evaluaciones;

        return momentElement;
      });

      if (value.duas.length > 0) {
        this.selectedDuaCategory = this.duas.find(
          (cat) => cat.id === value.duas[0].duacategory_id
        );
      }

      this.selectedDuas = uniqBy(value.duas, "id");

      if (value.pies && value.pies.length > 0) {
        this.pies = value.pies.map((pie: any) => {
          return {
            descripcion: pie.descripcion,
            evaluacion: pie.evaluacion,
            id_tipo_evaluacion: pie.id_tipo_evaluacion || (pie.tipoEvaluacion ? pie.tipoEvaluacion.id : null),
            id_tipo_instrumento_evaluacion: pie.id_tipo_instrumento_evaluacion || (pie.tipoInstrumentoEvaluacion ? pie.tipoInstrumentoEvaluacion.id : null),
            selectedDuas: this.duas.filter((dua) =>
              pie.idSelectedDuas.includes(dua.id)
            ),
            selectedIEs: pie.selectedIes,
            momentos: this.mapPieMoments(pie.momentos)
          };
        });
      } else {
        this.pies = [];
      }
      //this.request.files = value.files.slice(0);
    },
    show(refreshNeeded: Boolean, oasSelected: any = []): void {
      this.$emit("input", false);
      if (refreshNeeded) {
        this.$emit("activity-saved", {
          oasSelected: oasSelected,
          week: this.weekItem,
        });
      }
      this.request = this.requestDefaultValues();
      this.resetAll();
    },
    validAll() {
      this.valid = true;
      if (this.activityType == "" || this.activityType == null) {
        this.valid = false;
      }

      if (
        this.activityTitle == "" ||
        this.activityTitle == null ||
        this.activityTitle.length < 3
      ) {
        this.valid = false;
      }

      if (
        this.activityType == 1 &&
        (this.fechaClase == "" || this.fechaClase == null)
      ) {
        this.valid = false;
      }

      if (
        this.activityType == 2 &&
        (this.semanaClase == "" || this.semanaClase == null)
      ) {
        this.valid = false;
      }

      if (
        this.activityType == 3 &&
        (this.mesClase == "" || this.mesClase == null)
      ) {
        this.valid = false;
      }

      if (this.selectedIEs.length == 0) {
        this.valid = false;
      }

      if (this.selectedDuas.length == 0) {
        this.valid = false;
      }

      this.moments.forEach((moment) => {
        moment.error = false;

        if (moment.titulo == "" || moment.titulo == null) {
          moment.error = true;
          this.valid = false;
        }

        //html tags regex
        const tagRegex = /<[^>]*>/g;
        //no whitespaces regex
        const noWhiteSpaceRegex = /[^\s]+/g
        const actividadMomentoWithoutHtmlTags = moment && moment.actividadMomento ? moment.actividadMomento.replace(tagRegex, "") : "";
        if (
          moment.actividadMomento == "" ||
          moment.actividadMomento == null ||
          !noWhiteSpaceRegex.test(actividadMomentoWithoutHtmlTags)
        ) {
          moment.error = true;
          this.valid = false;
        }

        moment.evaluaciones.forEach((evaluation) => {
          evaluation.error = false;

          if (
            evaluation.actividadEvaluacion == "" ||
            evaluation.actividadEvaluacion == null ||
            evaluation.actividadEvaluacion.length < 5
          ) {
            evaluation.error = true;
            moment.error = true;
            this.valid = false;
          }

          if (
            evaluation.idTipoEvaluacion == "" ||
            evaluation.idTipoEvaluacion == null
          ) {
            evaluation.error = true;
            moment.error = true;
            this.valid = false;
          }

          if (
            evaluation.idTipoInstrumentoEvaluacion == "" ||
            evaluation.idTipoInstrumentoEvaluacion == null
          ) {
            evaluation.error = true;
            moment.error = true;
            this.valid = false;
          }
        });
      });

      this.pies.forEach((pie) => {
        let errorDuas = false;
        let errorIEs = false;

        if (!pie.descripcion || pie.descripcion.length < 3 || pie.descripcion.length > 200) {
          this.valid = false;
        }

        if (!pie.selectedDuas || pie.selectedDuas.length === 0) {
          errorDuas = true;
          this.valid = false;
        }

        if (!pie.selectedIEs || pie.selectedIEs.length === 0) {
          errorIEs = true;
          this.valid = false;
        }

        if (pie.errorDuas !== errorDuas) this.$set(pie, 'errorDuas', errorDuas);
        if (pie.errorIEs !== errorIEs) this.$set(pie, 'errorIEs', errorIEs);

        pie.momentos.forEach((moment) => {
          let momentError = false;

          if (!moment.titulo) {
            momentError = true;
            this.valid = false;
          }

          const tagRegex = /<[^>]*>/g;
          const noWhiteSpaceRegex = /[^\s]+/g
          const actividadMomentoWithoutHtmlTags = moment && moment.actividadMomento ? moment.actividadMomento.replace(tagRegex, "") : "";

          if (!moment.actividadMomento || !noWhiteSpaceRegex.test(actividadMomentoWithoutHtmlTags)) {
            momentError = true;
            this.valid = false;
          }

          if (moment.evaluaciones) {
            moment.evaluaciones.forEach((evaluation) => {
              let evaluationError = false;

              if (!evaluation.actividadEvaluacion || evaluation.actividadEvaluacion.length < 5) {
                evaluationError = true;
                momentError = true;
                this.valid = false;
              }

              if (!evaluation.idTipoEvaluacion) {
                evaluationError = true;
                momentError = true;
                this.valid = false;
              }

              if (!evaluation.idTipoInstrumentoEvaluacion) {
                evaluationError = true;
                momentError = true;
                this.valid = false;
              }

              if (evaluation.error !== evaluationError) this.$set(evaluation, 'error', evaluationError);
            });
          }

          if (moment.error !== momentError) this.$set(moment, 'error', momentError);
        });
      });
    },
    async getFileBlob(file) {
      let res = await vuex.dispatch(
        "getFileFromUrl",
        `actividad/file/${file.id}`
      );
      var newFile = new File([res.blob], file.name);
      return newFile;
    },
    addPie() {
      const momentos: any[] = [];
      const selectedIEs: any[] = [];
      if (this.activityType == '1') {
        momentos.push({
          titulo: 'Inicio',
          actividadMomento: null,
          files: [],
          evaluaciones: []
        });
        momentos.push({
          titulo: 'Desarrollo',
          actividadMomento: null,
          files: [],
          evaluaciones: []
        });
        momentos.push({
          titulo: 'Cierre',
          actividadMomento: null,
          files: [],
          evaluaciones: []
        });
      } else {
        momentos.push({
          titulo: this.activityType == '2' ? 'Semana' : 'Mes',
          actividadMomento: null,
          files: [],
          evaluaciones: []
        });
      }
      this.pies.push({
        descripcion: '',
        evaluacion: '',
        id_tipo_evaluacion: null,
        id_tipo_instrumento_evaluacion: null,
        selectedDuas: [],
        selectedIEs: this.selectedIEsBaseFromUnit,
        momentos: momentos
      });
    },
    removePie(index) {
      this.pies.splice(index, 1);
    },
    flattenOAs(oaList) {
      let ies = [];
      if (oaList && oaList.length > 0) {
        oaList.forEach((oa: any) => {
          if (oa.indicadores && oa.indicadores.length > 0) {
            oa.indicadores.forEach((ind: any) => ies.push(ind));
          }
          ies.push({ id: oa.id, oa_id: oa.id });
        });
      }
      return ies;
    },
    mapPieMoments(momentos) {
      if (!momentos) return [];
      return _.sortBy(momentos, 'id', 'asc').map((moment: any) => {
        return {
          id: moment.id,
          actividadMomento: moment.actividadMomento,
          titulo: moment.titulo,
          files: moment.fileList || moment.files || [],
          evaluaciones: moment.evaluaciones ? moment.evaluaciones.map((ev: any) => ({
            actividadEvaluacion: ev.actividadEvaluacion,
            idTipoEvaluacion: ev.idTipoEvaluacion || (ev.tipoEvaluacion ? ev.tipoEvaluacion.id : null),
            idTipoInstrumentoEvaluacion: ev.idTipoInstrumentoEvaluacion || (ev.tipoInstrumentoEvaluacion ? ev.tipoInstrumentoEvaluacion.id : null),
            files: ev.fileList || ev.files || []
          })) : []
        };
      });
    },
    async cleanPies() {
      const cleanPiesData = {
        pies: [],
        files: {}
      };

      for (const pie of this.pies) {
        const cleanPie = _.cloneDeep(pie);
        cleanPie.hash = _.uniqueId('pie_');

        // Process moments
        const cleanMoments = [];
        for (const moment of cleanPie.momentos) {
          const cleanMoment = _.cloneDeep(moment);
          cleanMoment.hash = _.uniqueId('pie_mom_');

          if (cleanMoment.files && cleanMoment.files.length > 0) {
            cleanPiesData.files[cleanMoment.hash] = [];
            for (const file of cleanMoment.files) {
              if (file.id) {
                const newFile = await this.getFileBlob(file);
                cleanPiesData.files[cleanMoment.hash].push(newFile);
              } else {
                cleanPiesData.files[cleanMoment.hash].push(file);
              }
            }
          }
          delete cleanMoment.files;

          // Process evaluations inside moment
          const cleanEvaluations = [];
          if (cleanMoment.evaluaciones) {
            for (const evaluation of cleanMoment.evaluaciones) {
              const cleanEvaluation = _.cloneDeep(evaluation);
              cleanEvaluation.hash = _.uniqueId('pie_mom_ev_');

              if (cleanEvaluation.files && cleanEvaluation.files.length > 0) {
                cleanPiesData.files[cleanEvaluation.hash] = [];
                for (const file of cleanEvaluation.files) {
                  if (file.id) {
                    const newFile = await this.getFileBlob(file);
                    cleanPiesData.files[cleanEvaluation.hash].push(newFile);
                  } else {
                    cleanPiesData.files[cleanEvaluation.hash].push(file);
                  }
                }
              }
              delete cleanEvaluation.files;
              cleanEvaluations.push(cleanEvaluation);
            }
          }
          cleanMoment.evaluaciones = cleanEvaluations;

          cleanMoments.push(cleanMoment);
        }
        cleanPie.momentos = cleanMoments;
        cleanPiesData.pies.push(cleanPie);
      }
      return cleanPiesData;
    },
    async cleanMoments() {
      const cleanMomentsWithFiles = {
        moments: [],
        files: {},
      };

      for (const moment of this.moments) {
        const cleanMoment = _.cloneDeep(moment);
        cleanMoment.hash = _.uniqueId();
        //(cleanMoment.files[0]);

        if (cleanMoment.files.length > 0 && cleanMoment.files[0].id) {
          cleanMomentsWithFiles.files[cleanMoment.hash] = [];
          for (const file of cleanMoment.files) {
            const newFile = await this.getFileBlob(file);
            cleanMomentsWithFiles.files[cleanMoment.hash].push(newFile);
          }
        } else {
          cleanMomentsWithFiles.files[cleanMoment.hash] = cleanMoment.files;
        }
        delete cleanMoment.files;
        delete cleanMoment.error;

        const cleanActivityEvaluations = [];
        for (const activityEvaluation of cleanMoment.evaluaciones) {
          const cleanActivityEvaluation = _.cloneDeep(activityEvaluation);
          cleanActivityEvaluation.hash = _.uniqueId();
          if (
            cleanActivityEvaluation.files.length > 0 &&
            cleanActivityEvaluation.files[0].id
          ) {
            cleanMomentsWithFiles.files[cleanActivityEvaluation.hash] = [];
            for (const file of cleanActivityEvaluation.files) {
              const newFile = await this.getFileBlob(file);
              cleanMomentsWithFiles.files[cleanActivityEvaluation.hash].push(
                newFile
              );
            }
          } else {
            cleanMomentsWithFiles.files[cleanActivityEvaluation.hash] =
              cleanActivityEvaluation.files;
          }
          delete cleanActivityEvaluation.files;
          delete cleanActivityEvaluation.error;
          cleanActivityEvaluations.push(cleanActivityEvaluation);
        }

        cleanMoment.evaluaciones = cleanActivityEvaluations;
        cleanMomentsWithFiles.moments.push(cleanMoment);
      }
      return cleanMomentsWithFiles;
    },
    async saveNew() {
      this.loading = true;
      const ies = this.selectedIEs.filter((ie) => ie.oa == null);
      const iesGrouped = groupBy(ies, "oa_id");
      const { moments, files } = await this.cleanMoments();
      const { pies, files: pieFiles } = await this.cleanPies();

      let request = {
        idPlanUnidad: this.unit.id,
        titulo: this.activityTitle,

        fechaClase: this.activityType == 1 ? this.fechaClase : null,
        semanaClase: this.semanaClase,
        mesClase: this.activityType == 3 ? this.mesClase : null,
        idSelectedDuas: this.selectedDuas.map((dua) => dua.id),
        selectedOAs: map(iesGrouped, (ies, index) => {
          return {
            id: index,
            idIndicadoresEvaluacion: ies.map((ie) => ie.id),
          };
        }),
        momentos: moments,

        // Actividad Instrumento
        actividadEnsenanza: " ",
        actividadEvaluacion: " ",
        idTipoInstrumentoEvaluacion: 1,
        idTipoEvaluacion: 1,
        idTipoActividad: parseInt(this.activityType),
        pies: pies.map(pie => {
          const pieIes = pie.selectedIEs.filter((ie: any) => ie.oa == null);
          const pieIesGrouped = groupBy(pieIes, "oa_id");
          return {
            descripcion: pie.descripcion,
            evaluacion: pie.evaluacion,
            id_tipo_evaluacion: pie.id_tipo_evaluacion,
            id_tipo_instrumento_evaluacion: pie.id_tipo_instrumento_evaluacion,
            idSelectedDuas: pie.selectedDuas.map((dua: any) => dua.id),
            selectedOAs: map(pieIesGrouped, (ies, index) => {
              return {
                id: index,
                idIndicadoresEvaluacion: ies.map((ie) => ie.id),
              };
            }),
            momentos: pie.momentos
          };
        })
      };
      if (this.activity && this.activity.id) {
        request.id = this.activity.id;
      }

      let msj = {
        show: true,
        text: "La actividad ha sido guardada con éxito",
        color: "success",
      };
      try {
        const response_end = await this.$store.dispatch(
          "setUnitPlanActivity",
          request
        );
        const fileHashes = response_end.data.content.hashes;
        const allFiles = { ...files, ...pieFiles };

        for (const hashElement of fileHashes) {
          try {
            if (allFiles[hashElement.hash]) {
              await this.$store.dispatch(
                "setUnitPlanActivityFiles",
                {
                  files: allFiles[hashElement.hash],
                  id: response_end.data.content.id,
                  entityType: hashElement.type,
                  entityId: hashElement.id,
                },
                { headers: { "Content-Type": "multipart/form-data" } }
              );
            }
          } catch (e) {
            msj.text = "Error al guardar archivos de actividad";
            msj.color = "red";
          }
        }
      } catch (e) {
        msj.text = "Error al guardar actividad";
        msj.color = "red";
      }
      if (msj.color == "success") {
        this.resetAll();
      }
      this.loading = false;
      this.$store.state.snackbar = msj;
      this.show(true, request.selectedOAs);
    },
    resetAll() {
      this.setDefaultValues();
      this.activityTitle = "";
      this.selectedIEs = [];
      this.selectedDuaCategory = null;
      this.selectedDuas = [];
      this.pies = [];

      if (this.activityType == 1) {
        this.moments = [this.requestDefaultValues("Inicio"), this.requestDefaultValues("Desarrollo"), this.requestDefaultValues("Cierre")];
      } else if (this.activityType == 2) {
        this.moments = [this.requestDefaultValues("Semana")]
      } else {
        this.moments = [this.requestDefaultValues("Mes")]
      }
    },
    
  },
  directives: {
    Ripple,
  },
  components: {
    TiptapVuetify,
    PlusIcon,
    TrashIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CalendarIcon,
    TipTap,
    XIcon,
    PaperclipIcon,
    RomaActivityPieForm
  },
});
